exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-text{color:#231f20;margin-top:5px;font-size:16px;font-weight:normal;font-style:normal;font-stretch:normal;letter-spacing:normal}#footer .full-screen{max-width:100%;padding-left:20px}", ""]);

// exports
